import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import Button from "../form/Button";
import connect from "react-redux/es/connect/connect";
import {showModal} from "../../actions";
import CompensationList from "./lists/CompensationList";
import CompensationForm from "./forms/CompensationForm";
import Portal from "../layout/Portal";
import TextInput from "../form/TextInput";
import {CurrencyFormatter} from "../../utils/formatters";
import Select from "../form/Select";
import DateTimeInput from "../form/DateTimeInput";
import {loadComponent} from "../../utils/components";
import Icon from "../form/Icon";

class RemainingButton extends React.Component {

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.values[prevProps.componentConfig.idfield] + "" !== "" + this.props.values[this.props.componentConfig.idfield]) {
            this.load();
        }
    }

    load = () => {
        this.setState({amount: 0}, () => {
            if (!(this.props.values[this.props.componentConfig.idfield] && (this.props.values.partner ||{}).partner_id)) return;
            this.loadBalanceFrom && this.loadBalanceFrom.abort();
            this.loadBalanceTo && this.loadBalanceTo.abort();

            this.loadBalanceFrom = loadComponent("componentlist", {
                withheader: 1,
                parentcomponent: this.props.componentConfig.componentname,
                parentid: this.props.values[this.props.componentConfig.idfield],
                listfield: "TransactionPayments",
                filter: [{field: "invoice.from", value: this.props.values.partner.partner_id}],
                itemsperpage: 1,
                aggregations: {
                    fields: {
                        "transaction.balance": {
                            field: "transaction.balance", type: "SUM"
                        }
                    }
                },
                view: ["transaction.balance"]
            });
            this.loadBalanceTo = loadComponent("componentlist", {
                withheader: 1,
                parentcomponent: this.props.componentConfig.componentname,
                parentid: this.props.values[this.props.componentConfig.idfield],
                listfield: "TransactionPayments",
                filter: [{field: "invoice.to", value: this.props.values.partner.partner_id}],
                itemsperpage: 1,
                aggregations: {
                    fields: {
                        "transaction.balance": {
                            field: "transaction.balance", type: "SUM"
                        }
                    }
                },
                view: ["transaction.balance"]
            });
            Promise.all([this.loadBalanceFrom, this.loadBalanceTo]).then((values) => {
                const fromBalance = Math.round(parseFloat(((values[1].aggregations || [])[0] || {})["transaction.balance"] || 0));
                const toBalance = Math.round(parseFloat(((values[0].aggregations || [])[0] || {})["transaction.balance"] || 0));
                if (fromBalance !== 0 || toBalance !== 0) {
                    this.setState({amount: fromBalance + toBalance});
                }
            });
        });
    }

    render() {
        return (
            (this.state ||{}).amount && (this.props.values.state || "0") + "" !== "0" ? <Button
                disabled={this.props.isLoading || this.props.dirty}
                color="primary"
                className="pull-right"
                onClick={(e) => this.props.remaining(this.state.amount, e)}
            >
                <span className="currency"><Icon lib="fas" name="money-bill-wave" />{" " + CurrencyFormatter(this.state.amount).props.children}</span>
            </Button> : null
        );
    }
}

class CompensationEditor extends React.Component {

    state = {
        message: null,
        messageType: null,
        opened: false,
        isLoading: false
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        if (!this.props.values[this.props.componentConfig.idfield]) {
            let data = {};
            if (this.props.values.moneyrepository === undefined) {
                data.moneyrepository = this.props.till.moneyrepositories.find((moneyrepository) => moneyrepository.component_type === "BankAccount") || null;
            }
            if (Object.keys(data).length) {
                await this.props.setFormValues({...this.props.values, ...data});
            }
        }
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || (this.props.values.state || "0") + "" !== "0";
        return props;
    }

    proceed = async (e) => {
        e && e.preventDefault();
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceed',
                data: values,
            });
            this.list && this.list.refreshBackground();
            this.form && this.form.refreshBackground();
            this.remainingButton && this.remainingButton.load();
            this.form.refreshLists && this.form.refreshLists();
            this.props.showModal({
                size: "small",
                theme: "success",
                header: "Sikeres művelet",
                text: "Sikeres lezárás!",
                timeout: 1500
            });
            return response;
        });
        this.setState({opened: false});
    }

    remaining = (amount = null, e) => {
        e && e.preventDefault();
        if (!this.state.opened) {
            this.setState({opened: true, amount});
            return;
        }
        const values = this.props.values;
        this.setState({isLoading: true}, async () => {
            try {
                await this.props.processAction(async () => {
                    const response = await postData({
                        action: this.props.componentConfig.componentname + '.remaining',
                        data: values,
                        moneyrepository: this.state.moneyrepository,
                        amount: this.state.amount,
                        transferdate: this.state.transferdate || null,
                    });
                    this.list && this.list.refreshBackground();
                    this.form && this.form.refreshBackground();
                    this.remainingButton && this.remainingButton.load();
                    this.form.refreshLists && this.form.refreshLists();
                    this.props.showModal({
                        size: "small",
                        theme: "success",
                        header: "Sikeres művelet",
                        text: "Sikeres lezárás!",
                        timeout: 1500
                    });
                    return response;
                });
                this.setState({opened: false, amount: 0, isLoading: false});
            } catch (e) {
                this.setState({opened: false, amount: 0, isLoading: false});
                throw e;
            }
        });
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <Modal
                    state={this.state.message !== null ? "on" : "off"}
                    theme={this.state.messageType}
                    size={"large"}
                    header={"Mentés"}
                    buttons={[
                        {
                            text: 'Ok',
                            onClose: true,
                            onClick: async () => {
                                this.setState({message: null, messageType: null});
                            }
                        }
                    ]}
                >
                    {this.state.message}
                </Modal>
                <List
                    {...this.props}
                    theme="default"
                    header="Kompenzációk"
                    footer={[
                        <Button
                            key="0"
                            color="default"
                            disabled={this.props.isLoading}
                            onClick={this.pristineForm}>
                            Új
                        </Button>
                    ]}
                >
                    <CompensationList
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Kompenzáció"
                    footer={<Fragment>
                        {
                            this.props.values[this.props.componentConfig.idfield] &&
                            <Fragment>
                                {this.state.opened && <Portal>
                                    <Modal
                                        state="on"
                                        header={this.state.amount > 0 ? "Bejövő pénz" : "Kifizetés"}
                                        size="small"
                                        buttons={[
                                            {
                                                text: "Mégse",
                                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                                onClose: true,
                                                onClick: async () => {
                                                    try {
                                                        this.setState({opened: false});
                                                    } catch (e) {

                                                    }
                                                }
                                            },
                                            {
                                                text: "Rögzítés",
                                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading || !this.state.moneyrepository},
                                                onClick: (e) => {
                                                    this.remaining(null, e);
                                                }
                                            }
                                        ]}
                                    >
                                        <div className="row form-row">
                                            <div className="col-md-12">
                                                <Select
                                                    label="Számla"
                                                    name="moneyrepository"
                                                    component="MoneyRepository"
                                                    filter={[{field: "component_type", value: "BankAccount"}]}
                                                    objectValue={true}
                                                    labelKey="name"
                                                    required={true}
                                                    valueKey="repository_id"
                                                    storeType="local"
                                                    value={this.state.moneyrepository}
                                                    saveChanges={(field, value) => this.setState({[field]: value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="row form-row">
                                            <div className="col-md-12 currency">
                                                <TextInput
                                                    type="decimal"
                                                    name="amount"
                                                    label="Összeg"
                                                    required={true}
                                                    formatter={CurrencyFormatter}
                                                    value={this.state.amount}
                                                    saveChanges={(field, value) => this.setState({[field]: value})}
                                                />
                                            </div>
                                        </div>
                                        <div className="row form-row">
                                            <div className="col-md-12">
                                                <DateTimeInput
                                                    name="transferdate"
                                                    label="Fizetés dátuma"
                                                    value={this.state.transferdate}
                                                    showTime={false}
                                                    saveChanges={(field, value) => this.setState({[field]: value})}
                                                />
                                            </div>
                                        </div>
                                    </Modal>
                                </Portal>}
                                <Button
                                    disabled={this.props.isLoading || this.props.dirty || (this.props.values.state || "0") + "" !== "0"}
                                    color="primary"
                                    className="pull-right"
                                    onClick={this.proceed}
                                >
                                    Lezárás
                                </Button>
                                {/*<RemainingButton
                                    ref={(remainingButton) => this.remainingButton = remainingButton}
                                    {...this.props}
                                    remaining={this.remaining}
                                />*/}
                            </Fragment>
                        }
                        <Button
                            disabled={this.props.isLoading || !this.props.dirty || (this.props.values.state || "0") + "" !== "0"}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    </Fragment>}
                >
                    <CompensationForm
                        ref={(form) => this.form = form}
                        {...this.props}
                        getFieldProps={this.getFieldProps}
                        reloadAmount={() => {
                            this.remainingButton && this.remainingButton.load();
                        }}
                    />
                </Editor>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
},{showModal})(createEditor({
    componentName: "Compensation",
    editor: "Compensation",
    WrappedComponent: CompensationEditor,
    props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
}));
